import { addHours as dateFnsAddHours } from 'date-fns';
import parseDate from './parseDate';

const addHours = (dateTime, hours) => {
  const parsedDateTime = parseDate(dateTime);

  return parsedDateTime ? dateFnsAddHours(parsedDateTime, hours) : null;
};

export default addHours;
